"use client"; // Indicate this is a client component

import React, { useEffect } from "react";
import PageLayout from "@/components/_shared/PageLayout";
import BulletpointsForm from "@/components/bulletpoints/BulletpointsForm";

export default function BulletpointsPage() {
	useEffect(() => {
		document.title = "Bulletpoints";
	}, []);

	return (
		<PageLayout title="Bulletpoints" toolId="bulletpoints">
			<main className="grid grid-cols-1 gap-6">
				<BulletpointsForm />
			</main>
		</PageLayout>
	);
}
